import { html } from './environment';

export const DEFAULT_VUE_DATA = (formEl = {}) => ({
    action: formEl.action || '',
    method: 'post',
    hasErrors: false,
    isLoading: false,
    isSubmitted: false,
    isResubmitable: true,
    formData: {},
    messages: []
})

export const FORM_MESSAGES = {
    VALIDITY: {
        en: 'There appears to be one or more errors.',
        fr: 'Il semble y avoir une ou plusieurs erreurs.',
    }
}

export const DEFAULT_VUE_FORM = {
    delimiters: ['${', '}'],
    validations: {
        formData: {},
    },
    computed: {
        /**
         * @return Array
         */
        hasMessages: function () {
            return this.messages.length > 0
        },
        /**
         * Set the correct classes according to the submit status
         *
         * @return Object
         */
        feedbackClasses: function () {
            return {
                'is-error': this.hasErrors,
                'is-loading': this.isLoading,
                'is-success': this.isSubmitted,
            }
        },
    },
    methods: {
        /**
         * Validate the field as the user interact with it.
         *
         * @param
         */
        inputClasses: (validation) => ({
            'is-error': validation.$error,
            'is-dirty': validation.$dirty,
        }),

        isSubmittable: function () {
            // Don't submit if loading
            if (this.isLoading) {
                return false
            }

            // Check if form can be resubmitted;
            // if form is not allowed to be resubmitted
            // BUT has not been submitted yet
            return this.isResubmitable || (!this.isResubmitable && !this.isSubmitted)
        },

        /**
         * Handle submit manually
         *
         * @param
         */
        submit: function () {
            if (!this.isSubmittable()) {
                console.warn('Form:', 'Not submittable')
                return
            }

            this.hasErrors = false
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.hasErrors = true

                // Scroll to 1st error
                requestAnimationFrame(() => {
                    const $inputError = this.$el.querySelectorAll('.is-error')[0]

                    if ($inputError && this.moduleInstance) {
                        this.moduleInstance.call('scrollTo', [$inputError, { duration: 600, offset: -200 }], 'Scroll')
                        $inputError.focus()
                    }
                })

                //temp
                this.messages = [{ message: FORM_MESSAGES.VALIDITY[html.lang] }]
            } else {
                this.sendData()
                this.$v.$reset()
            }
        },
        /**
         * Execute a POST fetch request.
         *
         * @return void
         */
        sendData: async function () {
            this.isLoading = true
            this.hasErrors = false
            this.messages = []

            try {
                const response = await fetch(this.action, {
                    method: this.method,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(this.formData),
                })

                if (response.status >= 400) {
                    this.hasErrors = true
                }

                const data = await response.json()

                console.log('Form:', response.status, data)

                if (this.hasErrors) {
                    this.messages = data
                    this.onSendDataFailure?.(data)
                } else {
                    this.onSendDataSuccess?.(data)
                    this.isSubmitted = true
                }
            } catch (error) {
                console.error('Form:', error)
            } finally {
                this.isLoading = false

                //Scroll to success
                requestAnimationFrame(() => {
                    const $success = this.$el.querySelectorAll('.c-form_success')[0]

                    if ($success && this.moduleInstance) {
                        this.moduleInstance.call('scrollTo', [$success, { duration: 600, offset: -200 }], 'Scroll')
                    }
                })

                this.onSendDataFinally?.()
            }
        },
    }
}
